import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const useKeyPress = (eventToBeTriggered: () => void, key: string = 'Enter'): { setIsPressed: Dispatch<SetStateAction<boolean>> } => {
	const [isPressed, setIsPressed] = useState(false);
	useEffect(() => {
		const onKeyDown = (e: any) => {
			if (e.key === key) {
				eventToBeTriggered();
			}
		};

		window.addEventListener('keydown', onKeyDown);
		return () => {
			window.removeEventListener('keydown', onKeyDown);
			setIsPressed(false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isPressed]);

	return {
		setIsPressed,
	};
};
export { useKeyPress };
